import React, { useState, useEffect, } from 'react';
import { useParams } from 'react-router-dom'
import {
  Container,
  List,
  Emp,
  ContainerDivs,
  DivAddEmp,
  AddEmp,
  DivDados,
  Grade,
  //SpanGradeStudent,
  SpanNameMatter,
  DadosStdt,
  ToGoBack,
  SignMessageButtonText,
  SignMessageButtonTextBold,
  PrintButton,
  SpanFrequency,
  DivBimTable,
  DivBimRow,
  DivBimHeader,
  DivBimCell,
  DivNameMatter,
  Preview,
  ContLogo,
  InfoContainer,
  UpContainer
} from './style';

import GlobalStyle from './style';

import {
  GetNumGrade,
  AttendanceFinalConcepts,
  indexNumericalGradesCard,
  getIstQuarter,
  getIIndQuarter,
  getIIIrdQuarter,
  getIVthQuarter,
  fetchLogo,
  clssInfo,
  GetMatter
} from '../../Api';

import { IoCheckmarkSharp, IoCloseSharp } from "react-icons/io5";

import { FcSurvey } from "react-icons/fc";

import { useNavigate } from 'react-router-dom';

import LoadingSpinner from '../../components/Loading';
import { NotaComRec, NotaComRecF, LegendaNotas, useRecuperacoes } from '../../components/Recuperacao';

const FinalConcepts = () => {

  const navigate = useNavigate()
  const [loading, setLoading] = useState(true);
  const [grade, setGrade] = useState([])
  const [stdtName, setStdtName] = useState([])
  const [teacherName, setTeacherName] = useState('')
  const [nameSchool, setNameSchool] = useState('')
  const [logoUrl, setLogoUrl] = useState('');
  const [matters, setMatter] = useState([]);
  const [year, setyear] = useState('')
  const [id_teacher, setId_teacher] = useState('')
  const [id_student, setid_student] = useState('')

  const [totalGrade, setTotalGrade] = useState([]);
  const [averageGrade, setAverageGrade] = useState([]);

  const [totalGradeIst, setTotalGradeIst] = useState([]);
  const [averageGradeIst, setAverageGradeIst] = useState([]);
  const [totalGradeIInd, setTotalGradeIInd] = useState([]);
  const [averageGradeIInd, setAverageGradeIInd] = useState([]);
  const [totalGradeIIIrd, setTotalGradeIIIrd] = useState([]);
  const [averageGradeIIIrd, setAverageGradeIIIrd] = useState([]);
  const [totalGradeIVth, setTotalGradeIVth] = useState([]);
  const [averageGradeIVth, setAverageGradeIVth] = useState([]);
  //const [totalGradeAnnual, setTotalGradeAnnual] = useState([]);
  //const [averageGradeAnnual, setAverageGradeAnnual] = useState([]);

  const [highlightedDays, setHighlightedDays] = React.useState([]);
  const [highlightedDaysF, setHighlightedDaysF] = React.useState([]);
  const [highlightedDaysFJ, setHighlightedDaysFJ] = React.useState([]);

  const [iStQuarter, setiStQuarter] = useState([]);
  const [iiNdQuarter, setiiNdQuarter] = useState([]);
  const [iiiRdQuarter, setIIIrdQuarter] = useState([]);
  const [ivThQuarter, setIVthQuarter] = useState([]);

  const [dataCla$$, setdataClass] = useState([]);

  const [assessmentRegime, setAssessmentRegime] = useState('');

  const { idClass } = useParams();

  const { recFinal, finalDe, recFinalAno } = useRecuperacoes({ id_class: idClass, id_student: sessionStorage.getItem('StudentInformation') });

  useEffect(() => {
    (async () => {
      setLoading(true);
      console.log("idClass", idClass)
      setAssessmentRegime(sessionStorage.getItem('assessmentRegime'))
      const resClass = await clssInfo(idClass);
      setdataClass(resClass)
      const $yearClass = resClass.data.data.find(clss => {
        return clss.year
      })
      const year = $yearClass.year
      const idSchool = JSON.parse(sessionStorage.getItem("id-school"));

      // matérias da escola na ordem do usuário (EF no fim)
      try {
        const resMatter = await GetMatter(idSchool);
        const EF_NAME = 'EDUCAÇÃO FÍSICA';
        const nrm = (s = '') => s.trim().toUpperCase();
        const rawMatters = resMatter.data.data || [];
        const orderedMatters = [...rawMatters].sort((a, b) => {
          const aEF = nrm(a.name) === EF_NAME;
          const bEF = nrm(b.name) === EF_NAME;
          if (aEF) return 1;
          if (bEF) return -1;
          return 0;
        });
        setMatter(orderedMatters);
      } catch (e) {
        console.error('Erro ao buscar matérias:', e);
      }

      const IstQuarter = await getIstQuarter(year, idSchool);
      const tgIst = IstQuarter.data.data.reduce((sum, res) => sum + Number(res.totalGrade || 0), 0);
      const agIst = IstQuarter.data.data.reduce((sum, res) => sum + Number(res.averageGrade || 0), 0);
      setTotalGradeIst(tgIst);
      setAverageGradeIst(agIst);

      const IIndQuarter = await getIIndQuarter(year, idSchool);
      const tgIInd = IIndQuarter.data.data.reduce((sum, res) => sum + Number(res.totalGrade || 0), 0);
      const agIInd = IIndQuarter.data.data.reduce((sum, res) => sum + Number(res.averageGrade || 0), 0);
      setTotalGradeIInd(tgIInd);
      setAverageGradeIInd(agIInd);

      const IIIrdQuarter = await getIIIrdQuarter(year, idSchool);
      const tgIIIrd = IIIrdQuarter.data.data.reduce((sum, res) => sum + Number(res.totalGrade || 0), 0);
      const agIIIrd = IIIrdQuarter.data.data.reduce((sum, res) => sum + Number(res.averageGrade || 0), 0);
      setTotalGradeIIIrd(tgIIIrd);
      setAverageGradeIIIrd(agIIIrd);

      const IVthQuarter = await getIVthQuarter(year, idSchool);
      const tgIVth = IVthQuarter.data.data.reduce((sum, res) => sum + Number(res.totalGrade || 0), 0);
      const agIVth = IVthQuarter.data.data.reduce((sum, res) => sum + Number(res.averageGrade || 0), 0);
      setTotalGradeIVth(tgIVth);
      setAverageGradeIVth(agIVth);

      const bimonthly = '1º BIMESTRE'
      const id_student = sessionStorage.getItem("StudentInformation");
      const nameSchool = sessionStorage.getItem("School");
      const stdtName = sessionStorage.getItem("stdt-name");
      setStdtName(stdtName)
      setyear(year)
      setNameSchool(nameSchool)
      setid_student(id_student)
      const resGrade = await GetNumGrade(year, bimonthly, id_student)
      setGrade(resGrade.data.data)
      console.log("resGrade", resGrade.data.data)

      if (resGrade.data.data) {
        const idTeacher = resGrade.data.data.map(res => {
          return res.id_class.classRegentTeacher
        })
        const Teacher = idTeacher[0];
        setId_teacher(Teacher)
        console.log("idTeacher", Teacher)
      }

      if (year && id_student) {
        const grades = await indexNumericalGradesCard(year, id_student)
        if (grades) {
          console.log("grades", grades.data.data);

          // Filtra os objetos para cada bimestre
          const firstQuarter = grades.data.data.filter(res => res.bimonthly === "1º BIMESTRE");
          const secondQuarter = grades.data.data.filter(res => res.bimonthly === "2º BIMESTRE");
          const thirdQuarter = grades.data.data.filter(res => res.bimonthly === "3º BIMESTRE");
          const fourthQuarter = grades.data.data.filter(res => res.bimonthly === "4º BIMESTRE");

          // Atualiza os estados com os arrays filtrados
          setiStQuarter(firstQuarter);
          setiiNdQuarter(secondQuarter);
          setIIIrdQuarter(thirdQuarter)
          setIVthQuarter(fourthQuarter)

          console.log("1º Bimestre", firstQuarter);
          console.log("2º Bimestre", secondQuarter);
        }
      }

      if (resGrade) {
        const allGrades = resGrade.data.data;

        // Verifica se há pelo menos uma matéria com o nome "EDUCAÇÃO FÍSICA"
        const hasPE = allGrades.some(res => res.id_matter.name === "EDUCAÇÃO FÍSICA");

        // Se tiver, move para o final; senão, mantém a ordem original
        const sortedResGrade = hasPE
          ? [
            ...allGrades.filter(res => res.id_matter.name !== "EDUCAÇÃO FÍSICA"),
            ...allGrades.filter(res => res.id_matter.name === "EDUCAÇÃO FÍSICA"),
          ]
          : allGrades;

        const tchr = sortedResGrade.map(res => res.id_teacher.name);
        const firstTeacher = tchr[0];  // Acessa o primeiro elemento
        console.log("firstTeacher", firstTeacher);
        setTeacherName(firstTeacher);  // Define apenas o primeiro elemento
      }
      const cachedLogo = localStorage.getItem(`school-logo-${idSchool}`);
      //const cachedLogoId = localStorage.getItem(`school-logo-id-${idSchool}`);

      if (cachedLogo) {
        console.log('busca pelo storage local')
        setLogoUrl(cachedLogo);
        //setlogoId(cachedLogoId);
      } else {

        console.log('busca no s3')
        const logoRes = await fetchLogo(idSchool);

        console.log('busca logo', logoRes)
        if (logoRes?.url) {
          setLogoUrl(logoRes.url);
          //setlogoId(logoRes._id);
          localStorage.setItem(`school-logo-${idSchool}`, logoRes.url);
          localStorage.setItem(`school-logo-id-${idSchool}`, logoRes._id);

        }
      }
      setLoading(false);
    })();

  }, [idClass]);

  useEffect(() => {
    if (
      totalGradeIst !== null && totalGradeIInd !== null &&
      totalGradeIIIrd !== null && totalGradeIVth !== null
    ) {
      setTotalGrade(totalGradeIst + totalGradeIInd + totalGradeIIIrd + totalGradeIVth);
    }

    if (
      averageGradeIst !== null && averageGradeIInd !== null &&
      averageGradeIIIrd !== null && averageGradeIVth !== null
    ) {
      setAverageGrade(
        (averageGradeIst + averageGradeIInd + averageGradeIIIrd + averageGradeIVth)
      );
    }
  }, [totalGradeIst, totalGradeIInd, totalGradeIIIrd, totalGradeIVth, averageGradeIst, averageGradeIInd, averageGradeIIIrd, averageGradeIVth]);

  useEffect(() => {
    const fetchAttendance = async () => {
      if (year && id_student && id_teacher) {
        try {
          const result = await AttendanceFinalConcepts(year, id_student, id_teacher);
          console.log("result", result)
          const data = result?.data?.data || [];

          // Verifique se os dados estão disponíveis e não estão vazios
          if (data.length > 0) {
            const attendance = data.filter(res => res.status === "P");
            const attendancef = data.filter(res => res.status === "F");
            const attendancefj = data.filter(res => res.status === "FJ");

            setHighlightedDays(attendance.length ? attendance : []);
            setHighlightedDaysF(attendancef.length ? attendancef : []);
            setHighlightedDaysFJ(attendancefj.length ? attendancefj : []);
          } else {
            console.warn("Nenhum dado de frequência disponível.");
          }
        } catch (error) {
          console.error("Erro ao obter dados de frequência", error);
        }
      }
    };

    fetchAttendance();
  }, [year, id_student, id_teacher]);

  const groupedGrades = grade.reduce((acc, grd) => {
    // Verifica se a matéria já existe no acumulador
    const existingMatter = acc.find(item => item.id_matter === grd.id_matter._id);

    if (!existingMatter) {
      // Se a matéria não existir no acumulador, adicionamos ela
      acc.push({
        idActivity: grd.idActivity,
        id_matter: grd.id_matter._id,
        matterName: grd.id_matter.name,
        grade: 0,  // Inicializa a soma das notas
      });
    }

    // Somando as notas, garantindo que sejam números (usando parseFloat)
    const totalGradeForMatter = parseFloat(grd.studentGrade) || 0;

    // Atualiza a soma das notas para a matéria no acumulador
    const updatedMatter = acc.find(item => item.id_matter === grd.id_matter._id);
    if (updatedMatter) {
      updatedMatter.grade += totalGradeForMatter;
    }

    return acc;
  }, []);

  const groupedGradesIst = iStQuarter.reduce((acc, grd) => {
    // Verifica se a matéria já existe no acumulador
    const existingMatter = acc.find(item => item.id_matter === grd.id_matter._id);

    if (!existingMatter) {
      // Se a matéria não existir no acumulador, adicionamos ela
      acc.push({
        idActivity: grd.idActivity,
        id_matter: grd.id_matter._id,
        matterName: grd.id_matter.name,
        grade: 0,  // Inicializa a soma das notas
      });
    }

    // Somando as notas, garantindo que sejam números (usando parseFloat)
    const totalGradeForMatter = parseFloat(
      grd.studentGrade.toString().replace(',', '.')
    ) || 0;

    // Atualiza a soma das notas para a matéria no acumulador
    const updatedMatter = acc.find(item => item.id_matter === String(grd.id_matter._id));
    if (updatedMatter) {
      updatedMatter.grade = parseFloat(
        (updatedMatter.grade + totalGradeForMatter).toFixed(2) // Garante duas casas decimais
      );
    }

    return acc;
  }, []);

  const groupedGradesIInd = iiNdQuarter.reduce((acc, grd) => {
    // Verifica se a matéria já existe no acumulador
    const existingMatter = acc.find(item => item.id_matter === grd.id_matter._id);

    if (!existingMatter) {
      // Se a matéria não existir no acumulador, adicionamos ela
      acc.push({
        idActivity: grd.idActivity,
        id_matter: grd.id_matter._id,
        matterName: grd.id_matter.name,
        grade: 0,  // Inicializa a soma das notas
      });
    }

    // Somando as notas, garantindo que sejam números (usando parseFloat)
    const totalGradeForMatter = parseFloat(
      grd.studentGrade.toString().replace(',', '.')
    ) || 0;

    // Atualiza a soma das notas para a matéria no acumulador
    const updatedMatter = acc.find(item => item.id_matter === grd.id_matter._id);
    if (updatedMatter) {
      updatedMatter.grade += totalGradeForMatter;
    }

    return acc;
  }, []);

  const groupedGradesIIIrd = iiiRdQuarter.reduce((acc, grd) => {
    // Verifica se a matéria já existe no acumulador
    const existingMatter = acc.find(item => item.id_matter === grd.id_matter._id);

    if (!existingMatter) {
      // Se a matéria não existir no acumulador, adicionamos ela
      acc.push({
        idActivity: grd.idActivity,
        id_matter: grd.id_matter._id,
        matterName: grd.id_matter.name,
        grade: 0,  // Inicializa a soma das notas
      });
    }

    // Somando as notas, garantindo que sejam números (usando parseFloat)
    const totalGradeForMatter = parseFloat(
      grd.studentGrade.toString().replace(',', '.')
    ) || 0;

    // Atualiza a soma das notas para a matéria no acumulador
    const updatedMatter = acc.find(item => item.id_matter === grd.id_matter._id);
    if (updatedMatter) {
      updatedMatter.grade += totalGradeForMatter;
    }

    return acc;
  }, []);

  const groupedGradesIVth = ivThQuarter.reduce((acc, grd) => {
    // Verifica se a matéria já existe no acumulador
    const existingMatter = acc.find(item => item.id_matter === grd.id_matter._id);

    if (!existingMatter) {
      // Se a matéria não existir no acumulador, adicionamos ela
      acc.push({
        idActivity: grd.idActivity,
        id_matter: grd.id_matter._id,
        matterName: grd.id_matter.name,
        grade: 0,  // Inicializa a soma das notas
      });
    }

    // Somando as notas, garantindo que sejam números (usando parseFloat)
    const totalGradeForMatter = parseFloat(
      grd.studentGrade.toString().replace(',', '.')
    ) || 0;

    // Atualiza a soma das notas para a matéria no acumulador
    const updatedMatter = acc.find(item => item.id_matter === grd.id_matter._id);
    if (updatedMatter) {
      updatedMatter.grade += totalGradeForMatter;
    }

    return acc;
  }, []);

  const messageButtonClick = () => {
    navigate(-1);
  };

  const handlePrint = () => {
    window.print();
  };

  const countPresences = highlightedDays.length;
  const countAbsences = highlightedDaysF.length;
  const countjustifiedAbsence = highlightedDaysFJ.length;

  const periodLabel = assessmentRegime === 'TRIMESTRAL' ? 'TRIM' : 'BIM';

  return (
    <Container>
      <GlobalStyle /> {/* Adicionando estilos globais */}
      {loading ? (
        <LoadingSpinner />
      ) : (
        <>
          <ContainerDivs>
            <div className="no-print">
              <h3>Atenção antes de imprimir</h3>
              <p>
                Caso o boletim possua muitas matérias e não caiba totalmente em uma única folha,
                diminua a <strong>escala de impressão</strong> nas configurações da impressora.
                Sugestão: <strong>90%</strong>, <strong>85%</strong> ou <strong>80%</strong>.
              </p>
            </div>
            <PrintButton className="no-print" onClick={handlePrint}>
              Imprimir
            </PrintButton>
            <DivAddEmp id="containerDivs">
              <ContLogo>
                {(logoUrl) && (
                  <Preview src={logoUrl} alt="Logo da escola" />
                )}
                <h2>Boletim</h2>
              </ContLogo>
              <AddEmp>
                <h3>Resultado Final</h3>
              </AddEmp>
              <DadosStdt>
                <UpContainer>
                  <InfoContainer>
                    <span><strong>Escola:</strong> {nameSchool}</span>
                    <span>
                      <strong>Série:</strong> {dataCla$$?.data?.data?.[0]?.serie}
                    </span>

                    <span>
                      <strong>Turma:</strong> {dataCla$$?.data?.data?.[0]?.name}
                    </span>

                    <span>
                      <strong>Ano Letivo:</strong> {dataCla$$?.data?.data?.[0]?.year}
                    </span>
                    <span><strong>Professor:</strong> {teacherName}</span>
                    <span><strong>Aluno:</strong> {stdtName}</span>
                  </InfoContainer>
                  <SpanFrequency>
                    <span><IoCheckmarkSharp color='#00fa00' font-size="30px" />Presenças: {countPresences} | <IoCloseSharp color='#ff050a' font-size="30px" />Ausências: {countAbsences}</span>
                    <span><FcSurvey font-size="25px" />Faltas Justificadas: {countjustifiedAbsence}</span>
                  </SpanFrequency>
                </UpContainer>

                <LegendaNotas total={totalGrade} media={averageGrade} totalLabel="Total anual" mediaLabel="Média anual" recFinal />
              </DadosStdt>
              <DivDados>
                <List>
                  {groupedGrades
                    .sort((a, b) => {
                      // ordena conforme a ordem definida pelo usuário (campo
                      // `order` vindo do GetMatter), com a Educação Física no fim
                      const norm = (s = '') => s.trim().toUpperCase();
                      const orderIndex = new Map((matters || []).map((m, i) => [norm(m.name), i]));
                      const big = Number.MAX_SAFE_INTEGER;
                      const ia = orderIndex.has(norm(a.matterName)) ? orderIndex.get(norm(a.matterName)) : big;
                      const ib = orderIndex.has(norm(b.matterName)) ? orderIndex.get(norm(b.matterName)) : big;
                      return ia - ib;
                    })
                    .map(grd => {
                      const getGrade = (grouped, id) => {
                        return grouped.find(res => String(res.id_matter) === String(id))?.grade || 0;
                      };

                      const gradeIst = getGrade(groupedGradesIst, grd.id_matter);
                      const gradeIInd = getGrade(groupedGradesIInd, grd.id_matter);
                      const gradeIIIrd = getGrade(groupedGradesIIIrd, grd.id_matter);
                      const gradeIVth = getGrade(groupedGradesIVth, grd.id_matter);

                      // total do ano com a nota final de cada período (recuperação já aplicada)
                      const totalGrade = finalDe(1, null, grd.matterName, gradeIst, averageGradeIst) +
                        finalDe(2, null, grd.matterName, gradeIInd, averageGradeIInd) +
                        finalDe(3, null, grd.matterName, gradeIIIrd, averageGradeIIIrd) +
                        finalDe(4, null, grd.matterName, gradeIVth, averageGradeIVth);

                      const isHistoryIst = groupedGradesIst.some(
                        res =>
                          String(res.id_matter) === String(grd.id_matter) &&
                          !res.idActivity
                      );

                      const isHistoryIInd = groupedGradesIInd.some(
                        res =>
                          String(res.id_matter) === String(grd.id_matter) &&
                          !res.idActivity
                      );

                      const isHistoryIIIrd = groupedGradesIIIrd.some(
                        res =>
                          String(res.id_matter) === String(grd.id_matter) &&
                          !res.idActivity
                      );

                      const isHistoryIVth = groupedGradesIVth.some(
                        res =>
                          String(res.id_matter) === String(grd.id_matter) &&
                          !res.idActivity
                      );

                      return (
                        <Emp key={grd._id}>
                          <DivNameMatter>
                            <SpanNameMatter>{grd.matterName}</SpanNameMatter>
                          </DivNameMatter>

                          <Grade>
                            <DivBimTable>

                              <DivBimRow>
                                <DivBimHeader>1º {periodLabel}</DivBimHeader>
                                <DivBimCell
                                  grade={gradeIst}
                                  averageGrade={parseFloat(averageGradeIst) || 0}
                                  totalGrade={parseFloat(totalGradeIst) || 0}
                                  isHistory={isHistoryIst}
                                >
                                  {gradeIst > 0 ? <NotaComRec nota={gradeIst} rec={recFinal(1, null, grd.matterName, gradeIst, averageGradeIst)} /> : '-'}
                                </DivBimCell>
                              </DivBimRow>

                              <DivBimRow>
                                <DivBimHeader>2º B{periodLabel}</DivBimHeader>
                                <DivBimCell
                                  grade={gradeIInd}
                                  averageGrade={parseFloat(averageGradeIInd) || 0}
                                  totalGrade={parseFloat(totalGradeIInd) || 0}
                                  isHistory={isHistoryIInd}
                                >
                                  {gradeIInd > 0 ? <NotaComRec nota={gradeIInd} rec={recFinal(2, null, grd.matterName, gradeIInd, averageGradeIInd)} /> : '-'}
                                </DivBimCell>
                              </DivBimRow>

                              <DivBimRow>
                                <DivBimHeader>3º {periodLabel}</DivBimHeader>
                                <DivBimCell
                                  grade={gradeIIIrd}
                                  averageGrade={parseFloat(averageGradeIIIrd) || 0}
                                  totalGrade={parseFloat(totalGradeIIIrd) || 0}
                                  isHistory={isHistoryIIIrd}
                                >
                                  {gradeIIIrd > 0 ? <NotaComRec nota={gradeIIIrd} rec={recFinal(3, null, grd.matterName, gradeIIIrd, averageGradeIIIrd)} /> : '-'}
                                </DivBimCell>
                              </DivBimRow>

                              {assessmentRegime !== 'TRIMESTRAL' && (
                                <DivBimRow>
                                  <DivBimHeader>4º {periodLabel}</DivBimHeader>
                                  <DivBimCell
                                    grade={gradeIVth}
                                    averageGrade={parseFloat(averageGradeIVth) || 0}
                                    totalGrade={parseFloat(totalGradeIVth) || 0}
                                    isHistory={isHistoryIVth}
                                  >
                                    {gradeIVth > 0 ? <NotaComRec nota={gradeIVth} rec={recFinal(4, null, grd.matterName, gradeIVth, averageGradeIVth)} /> : '-'}
                                  </DivBimCell>
                                </DivBimRow>
                              )}

                              <DivBimRow>
                                <DivBimHeader>Total</DivBimHeader>
                                <DivBimCell
                                  grade={parseFloat(totalGrade)}
                                  averageGrade={
                                    parseFloat(averageGradeIst) +
                                    parseFloat(averageGradeIInd) +
                                    parseFloat(averageGradeIIIrd) +
                                    parseFloat(averageGradeIVth)
                                  }
                                  totalGrade={
                                    parseFloat(totalGradeIst) +
                                    parseFloat(totalGradeIInd) +
                                    parseFloat(totalGradeIIIrd) +
                                    parseFloat(totalGradeIVth)
                                  }
                                >
                                  <NotaComRecF nota={totalGrade} recF={recFinalAno(null, grd.matterName, totalGrade)} />
                                </DivBimCell>
                              </DivBimRow>

                            </DivBimTable>
                          </Grade>
                        </Emp>
                      );
                    })}
                </List>
              </DivDados>
            </DivAddEmp>
          </ContainerDivs>
          <ToGoBack onClick={messageButtonClick}>
            <SignMessageButtonText>Voltar para o</SignMessageButtonText>
            <SignMessageButtonTextBold>Perfil do Aluno</SignMessageButtonTextBold>
          </ToGoBack>
        </>
      )}
    </Container>
  )
}

export default FinalConcepts